/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCallDetailFromJSON, StreemApiCallDetailToJSON, StreemApiGroupFromJSON, StreemApiGroupToJSON, StreemApiGroupReservationDetailFromJSON, StreemApiGroupReservationDetailToJSON, StreemApiUserFromJSON, StreemApiUserToJSON, } from './';
export function StreemApiGroupReservationFromJSON(json) {
    return StreemApiGroupReservationFromJSONTyped(json, false);
}
export function StreemApiGroupReservationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'group': !exists(json, 'group') ? undefined : StreemApiGroupFromJSON(json['group']),
        'reservationSid': !exists(json, 'reservation_sid') ? undefined : json['reservation_sid'],
        'externalUserId': !exists(json, 'external_user_id') ? undefined : json['external_user_id'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'reserveForSeconds': !exists(json, 'reserve_for_seconds') ? undefined : json['reserve_for_seconds'],
        'reservationStatus': !exists(json, 'reservation_status') ? undefined : json['reservation_status'],
        'queuePosition': !exists(json, 'queue_position') ? undefined : json['queue_position'],
        'reservedUser': !exists(json, 'reserved_user') ? undefined : StreemApiUserFromJSON(json['reserved_user']),
        'reservedUntil': !exists(json, 'reserved_until') ? undefined : (new Date(json['reserved_until'])),
        'connectedAt': !exists(json, 'connected_at') ? undefined : (new Date(json['connected_at'])),
        'completedAt': !exists(json, 'completed_at') ? undefined : (new Date(json['completed_at'])),
        'details': !exists(json, 'details') ? undefined : (json['details'].map(StreemApiGroupReservationDetailFromJSON)),
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
        'initiatedAt': !exists(json, 'initiated_at') ? undefined : (new Date(json['initiated_at'])),
        'failedAt': !exists(json, 'failed_at') ? undefined : (new Date(json['failed_at'])),
        'expiredAt': !exists(json, 'expired_at') ? undefined : (new Date(json['expired_at'])),
        'requestedAt': !exists(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'estimatedWaitUntil': !exists(json, 'estimated_wait_until') ? undefined : (new Date(json['estimated_wait_until'])),
        'referenceId': !exists(json, 'reference_id') ? undefined : json['reference_id'],
        'integrationId': !exists(json, 'integration_id') ? undefined : json['integration_id'],
        'reconnectPreviousReservationSid': !exists(json, 'reconnect_previous_reservation_sid') ? undefined : json['reconnect_previous_reservation_sid'],
        'callDetail': !exists(json, 'call_detail') ? undefined : StreemApiCallDetailFromJSON(json['call_detail']),
        'previousReservationSid': !exists(json, 'previous_reservation_sid') ? undefined : json['previous_reservation_sid'],
        'reservationType': !exists(json, 'reservation_type') ? undefined : json['reservation_type'],
    };
}
export function StreemApiGroupReservationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company_sid': value.companySid,
        'group': StreemApiGroupToJSON(value.group),
        'reservation_sid': value.reservationSid,
        'external_user_id': value.externalUserId,
        'priority': value.priority,
        'reserve_for_seconds': value.reserveForSeconds,
        'reservation_status': value.reservationStatus,
        'queue_position': value.queuePosition,
        'reserved_user': StreemApiUserToJSON(value.reservedUser),
        'reserved_until': value.reservedUntil === undefined ? undefined : (value.reservedUntil.toISOString()),
        'connected_at': value.connectedAt === undefined ? undefined : (value.connectedAt.toISOString()),
        'completed_at': value.completedAt === undefined ? undefined : (value.completedAt.toISOString()),
        'details': value.details === undefined ? undefined : (value.details.map(StreemApiGroupReservationDetailToJSON)),
        'room_sid': value.roomSid,
        'initiated_at': value.initiatedAt === undefined ? undefined : (value.initiatedAt.toISOString()),
        'failed_at': value.failedAt === undefined ? undefined : (value.failedAt.toISOString()),
        'expired_at': value.expiredAt === undefined ? undefined : (value.expiredAt.toISOString()),
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt.toISOString()),
        'estimated_wait_until': value.estimatedWaitUntil === undefined ? undefined : (value.estimatedWaitUntil.toISOString()),
        'reference_id': value.referenceId,
        'integration_id': value.integrationId,
        'reconnect_previous_reservation_sid': value.reconnectPreviousReservationSid,
        'call_detail': StreemApiCallDetailToJSON(value.callDetail),
        'previous_reservation_sid': value.previousReservationSid,
        'reservation_type': value.reservationType,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiGroupReservationReservationStatus;
(function (StreemApiGroupReservationReservationStatus) {
    StreemApiGroupReservationReservationStatus["CANCELED"] = "GROUP_RESERVATION_STATUS_CANCELED";
    StreemApiGroupReservationReservationStatus["COMPLETED"] = "GROUP_RESERVATION_STATUS_COMPLETED";
    StreemApiGroupReservationReservationStatus["CONFIRMING"] = "GROUP_RESERVATION_STATUS_CONFIRMING";
    StreemApiGroupReservationReservationStatus["CONNECTED"] = "GROUP_RESERVATION_STATUS_CONNECTED";
    StreemApiGroupReservationReservationStatus["EXPIRED"] = "GROUP_RESERVATION_STATUS_EXPIRED";
    StreemApiGroupReservationReservationStatus["FAILED"] = "GROUP_RESERVATION_STATUS_FAILED";
    StreemApiGroupReservationReservationStatus["INITIATED"] = "GROUP_RESERVATION_STATUS_INITIATED";
    StreemApiGroupReservationReservationStatus["INVALID"] = "GROUP_RESERVATION_STATUS_INVALID";
    StreemApiGroupReservationReservationStatus["MATCHED"] = "GROUP_RESERVATION_STATUS_MATCHED";
    StreemApiGroupReservationReservationStatus["NOTMATCHED"] = "GROUP_RESERVATION_STATUS_NOT_MATCHED";
    StreemApiGroupReservationReservationStatus["QUEUED"] = "GROUP_RESERVATION_STATUS_QUEUED";
})(StreemApiGroupReservationReservationStatus || (StreemApiGroupReservationReservationStatus = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiGroupReservationReservationType;
(function (StreemApiGroupReservationReservationType) {
    StreemApiGroupReservationReservationType["ORIGIN"] = "RESERVATION_TYPE_ORIGIN";
    StreemApiGroupReservationReservationType["RECONNECT"] = "RESERVATION_TYPE_RECONNECT";
    StreemApiGroupReservationReservationType["REQUEUE"] = "RESERVATION_TYPE_REQUEUE";
    StreemApiGroupReservationReservationType["INVALID"] = "RESERVATION_TYPE_INVALID";
})(StreemApiGroupReservationReservationType || (StreemApiGroupReservationReservationType = {}));
//# sourceMappingURL=StreemApiGroupReservation.js.map